.container {
  position: relative;

  display: flex;
  align-items: center;

  background-color: var(--color-error);
  padding: 1rem;
  text-align: center;
  color: var(--color-text-light-solid);
}

.text {
  width: 100%;
  color: var(--color-text-light-solid);

  &::selection {
    background-color: var(--tekhelet-3);
  }

  & strong {
    color: var(--color-text-light-solid);
  }
}

.button {
  position: absolute;
  right: 1rem;
  white-space: nowrap;
  background-color: var(--tekhelet-3);
  border: none;
  font-weight: 600;

  &:hover {
    background-color: var(--tekhelet-4);
  }

  &:focus {
    background-color: var(--tekhelet-5);
  }
}
